import { render, staticRenderFns } from "./SettingsScreen.vue?vue&type=template&id=33d617b0&"
import script from "./SettingsScreen.vue?vue&type=script&lang=js&"
export * from "./SettingsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports